$(function () {
    // Page: Careers View

    $.validator.addMethod(
        'filesize',
        function (value, element, param) {
            return this.optional(element) || element.files[0].size <= param
        },
        window.validationMessages['file.filesize']
    )

    let form = $('#apply-form')
    let formElements = $('form input, form textarea, form select')
    let submitFormElement = $('.submit-form')
    let processingText = submitFormElement.data('processing')
    let recaptchaLoaded = false

    form.validate({
        ignore: [],
        rules: {
            apply_name: {
                required: true
            },
            apply_email: {
                required: true,
                email: true
            },
            apply_telephone: {
                required: true,
                number: true
            },
            apply_text: {
                required: true
            },
            apply_privacy: {
                required: true
            },
            cv_file: {
                required: true,
                filesize: 8 * Math.pow(10, 6) * 4 // Should be in bits
            },
            other_file: {
                filesize: 8 * Math.pow(10, 6) * 4 // Should be in bits
            }
        },
        messages: {
            apply_name: {
                required: window.validationMessages['name.required']
            },
            apply_email: {
                required: window.validationMessages['email.required'],
                email: window.validationMessages['email.email']
            },
            apply_telephone: {
                required: window.validationMessages['phone.required'],
                number: window.validationMessages['phone.number']
            },
            apply_text: {
                required: window.validationMessages['text.required']
            },
            apply_privacy: {
                required: window.validationMessages['terms.accepted']
            },
            cv_file: {
                required: window.validationMessages['cv.required'],
                filesize: window.validationMessages['file.filesize_4mb']
            },
            other_file: {
                filesize: window.validationMessages['file.filesize_4mb']
            }
        },
        highlight: function (element) {
            $(element).parent().addClass('group-error')
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('group-error')
        }
    })

    $('input[type=file]').on('change', function () {
        var text = $(this).val()
        text = text.substring(text.lastIndexOf('\\') + 1, text.length)

        if ($(this).closest('.upload-cv-container').length > 0 && $('#upload-cv').valid()) {
            $('.uploaded-files .upload-cv')
                .html('')
                .append('<i class="icon icon-uncheck"></i>' + text)
        }

        if ($(this).closest('.upload-other-container').length > 0 && $('#upload-other').valid()) {
            $('.uploaded-files .upload-other')
                .html('')
                .append('<i class="icon icon-uncheck"></i>' + text)
        }
    })

    $('.uploaded-files a').on('click', function (e) {
        e.preventDefault()

        var file = $(this).attr('class')

        $(this).text('')
        $('#' + file).val(null)
    })

    formElements.on('focus', function () {
        if (recaptchaLoaded !== true) {
            let head = document.getElementsByTagName('head')[0]
            let recaptchaScript = document.createElement('script')

            recaptchaScript.type = 'text/javascript'
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js'
            head.appendChild(recaptchaScript)

            recaptchaLoaded = true
        }
    })

    window.shouldNotSubmit = true
    window.formToSubmit = null

    form.on('submit', function (e) {
        if (window.shouldNotSubmit && $(this).valid()) {
            e.preventDefault()

            submitFormElement.prop('disabled', true).val(processingText)

            window.formToSubmit = $(this)
            grecaptcha.execute()

            console.log('Form submitted successfully!')
        }
    })

    window.insertIntoForm = function () {
        let recaptchaResponse = grecaptcha.getResponse()
        form.append('<input type="hidden" name="g-recaptcha-response" value="' + recaptchaResponse + '" />')
        window.shouldNotSubmit = false

        submitFormElement.prop('disabled', false)
        submitFormElement.trigger('click').prop('disabled', true)
    }
})
